import db from '../../versa/db.js';

export default async (results) =>		// { company_id: { order_id: { fulfillment, status, customer_nick, carrier_nick, program_name, items, positions_count }, ... } }
{
	if (!results || typeof results !== 'object')
		return '<p>Nenhum resultado disponível.</p>';

	const rows = [];
	for (const company_id of Object.keys(results)) {
		const company_nick = (await db.get('companies', company_id))?.nick ?? company_id;
		for (const order_id of Object.keys(results[company_id] || {})) {
			const rec = results[company_id][order_id];
			const items = rec?.items ?? [];
			rows.push(`
				<tr><td class="tal" colspan="2"><strong>${company_nick}</strong></td></tr>
				<tr><td class="tal" style="width: 140px;">Cliente</td><td class="tal">${escapeHtml(rec?.customer_nick ?? '')}</td></tr>
				<tr><td class="tal">Pedido</td><td class="tal">${order_id}</td></tr>
				<tr><td class="tal">Transportador</td><td class="tal">${escapeHtml(rec?.carrier_nick ?? '')}</td></tr>
				<tr><td class="tal">Programa</td><td class="tal">${escapeHtml(rec?.program_name ?? '')}</td></tr>
				<tr><td class="tal">% total de atendimento</td><td class="tal"><strong>${rec?.fulfillment ?? 0}%</strong></td></tr>
				<tr><td class="tal">Posições atendidas</td><td class="tal">${rec?.positions_count ?? 0}</td></tr>
				<tr><td class="tal" colspan="2" style="padding-top: var(--space-md);">${rec?.status ?? ''}</td></tr>
				${rec?.reservation_note ? `
				<tr><td class="tal" colspan="2" style="padding: var(--space-md); background: #fff7ed; border: 1px solid #fdba74; border-radius: 6px;">
					${escapeHtml(rec.reservation_note)}
				</td></tr>
				` : ''}
				${items.length > 0 ? `
				<tr><td colspan="2" style="padding-top: var(--space-sm);">
					<table class="stats-items" style="width: 100%; border-collapse: collapse; font-size: 0.9em;">
						<thead><tr>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">SKU</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Nome</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Lote Fabricante</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Unidade</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">Solicitado</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">Atendido</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">%</th>
							<th class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">Posição</th>
							<th class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">Embalagem sugerida</th>
						</tr></thead>
						<tbody>
						${items.map(it => `
							<tr>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.sku)}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.product_name)}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.lot_number)}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.unit_symbol)}</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.quantity_ordered ?? 0}</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.quantity_supplied ?? 0}</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.fulfillment_pct ?? 0}%</td>
								<td class="tar" style="border: 1px solid #ccc; padding: 4px 6px;">${it.position ?? ''}</td>
								<td class="tal" style="border: 1px solid #ccc; padding: 4px 6px;">${escapeHtml(it.packaging_plan || '')}</td>
							</tr>
						`).join('')}
						</tbody>
					</table>
				</td></tr>
				` : ''}
			`);
		}
	}

	function escapeHtml(s) {
		if (s == null) return '';
		const t = document.createElement('div');
		t.textContent = String(s);
		return t.innerHTML;
	}

	return `<style>
		#stats { width: 100%; border-collapse: collapse; }
		#stats td { padding: var(--space-sm); }
		.stats-items th, .stats-items td { font-weight: normal; }
	</style>
	<table id="stats">${rows.join('')}</table>`;
};
